import { INavDrawerLink, NavDrawerLink } from 'es/app/components/layout/nav/NavDrawerLink';
import styles from './NavDrawerLinkList.module.css';

export const NavDrawerLinkList = ({ items }: { items: INavDrawerLink[] }) => {
    return (
        <div className={styles.navDrawerLinkList}>
            {items.map(item => (
                <NavDrawerLink key={item.route} {...item} />
            ))}
        </div>
    );
};
